import React, { Component } from 'react'
import ResetPasswordScreen from '../ResetPassword/ResetPasswordScreen'

class App extends Component {
  render () {
    return (
      <ResetPasswordScreen />
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/containers/App/App.js